import * as FingerPrint from 'fingerprintjs2';

export default async function getFingerPrint(): Promise<string> {
    return new Promise((resolve, reject) => {
        FingerPrint.getV18((hash: string) => {
            resolve(hash);
        })
    })
}
